exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bodyPublic .XVcolDetail{display:none}.bodyPublic .XVdetailRow{word-break:inherit}.bodyPublic #lblBeschrijving{height:auto}.bodyPublic .loader{width:40px!important;height:40px!important}", ""]);

// exports
